import { styled } from "@mui/material";
import { detailRowName } from "../classes.js";
const EmptyIcon = styled("svg", {
  name: detailRowName,
  slot: "EmptyIcon"
})(() => {
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    fill: "currentColor",
    flexShrink: 0,
    fontSize: "inherit"
  };
});
export {
  EmptyIcon
};
//# sourceMappingURL=EmptyIcon.js.map
